/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.membership.pricing.controllers', [])

.controller('MembershipPricingController', ['$scope', function($scope) {

    $scope.membershipPricing = {

      model: "",

      init: function() {},

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.membershipPricing.init();

}]);